import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import HakkimizdaPage from './pages/HakkimizdaPage';
import HizmetlerPage from './pages/HizmetlerPage';
import RandevuPage from './pages/RandevuPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import SSSPage from './pages/SSSPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import WiderrufPage from './pages/WiderrufPage';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import SeoHead from './components/SeoHead';
import AnalyticsTracker from './components/AnalyticsTracker';
import { ROUTES, SERVICE_ROUTES } from './data/siteLinks';
import NotFoundPage from './pages/NotFoundPage';
import './styles/global.css';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <SeoHead />
      <AnalyticsTracker />
      <Header />
      <main>
        <Routes>
          <Route path={ROUTES.home} element={<HomePage />} />
          <Route path={ROUTES.about} element={<HakkimizdaPage />} />
          <Route path={ROUTES.services} element={<HizmetlerPage />} />
          <Route path={SERVICE_ROUTES.education} element={<HizmetlerPage category="egitim" />} />
          <Route path={SERVICE_ROUTES.visa} element={<HizmetlerPage category="vize" />} />
          <Route path={SERVICE_ROUTES.housing} element={<HizmetlerPage category="kiralama" />} />
          <Route path={SERVICE_ROUTES.residence} element={<HizmetlerPage category="oturum" />} />
          <Route path={SERVICE_ROUTES.integration} element={<HizmetlerPage category="entegrasyon" />} />
          <Route path={SERVICE_ROUTES.postMigration} element={<HizmetlerPage category="goc-sonrasi" />} />
          <Route path={ROUTES.appointment} element={<RandevuPage />} />
          <Route path={ROUTES.blog} element={<BlogPage />} />
          <Route path="/blog" element={<Navigate to={ROUTES.blog} replace />} />
          <Route path="/post/:slug" element={<BlogPostPage />} />
          <Route path={ROUTES.faq} element={<SSSPage />} />
          <Route path={ROUTES.impressum} element={<ImpressumPage />} />
          <Route path={ROUTES.privacy} element={<DatenschutzPage />} />
          <Route path={ROUTES.withdrawal} element={<WiderrufPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </Router>
  );
};

export default App;
